import { render, staticRenderFns } from "./PaginationSection.vue?vue&type=template&id=88219b4e&scoped=true"
import script from "./PaginationSection.vue?vue&type=script&lang=js"
export * from "./PaginationSection.vue?vue&type=script&lang=js"
import style0 from "./PaginationSection.vue?vue&type=style&index=0&id=88219b4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88219b4e",
  null
  
)

export default component.exports